export {
    TRADE_WELCOME_PROMO_CODE,
    TRADE_FIRST_WELCOME_PROMO_CODE,
} from '../src/notificationQueue/globalNotifications/tradePromos/constants';
